export default __webpack_public_path__ + "static/media/Icon-memo.fefcef17.svg";